module.exports = __webpack_public_path__ + "static/img/healthy.png";